/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const SELL_BALANCE_ENABLED_FLAG = 'BOO-3170-(sell-balance)' as const;
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const ACCESSORIES_CHECKLIST_FLAG =
    'LOVE-1153-(sell-journey-accessories-checklist)' as const;
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const VAT_REGISTERED_BUY_FLAG = 'BOO-3485-(vat-registered-buy)' as const;
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const NL_SEARCH_FLAG = 'TUR-3496-(nl-search)' as const;
